import { render, staticRenderFns } from "./CreatePurchase.vue?vue&type=template&id=4b5ad3c2&scoped=true&"
import script from "./CreatePurchase.vue?vue&type=script&lang=js&"
export * from "./CreatePurchase.vue?vue&type=script&lang=js&"
import style0 from "./CreatePurchase.vue?vue&type=style&index=0&id=4b5ad3c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5ad3c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VIcon,VTextField,VTextarea})
